/* eslint-disable import/prefer-default-export */
import DashLatex from './components/DashLatex.react';
import 'katex/dist/katex.min.css';

export {DashLatex};
